import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BucketHeader from './BucketHeader';
import MediaCardContent from 'eventbrite_design_system/mediaCardContent/MediaCardContent';
import Card from 'eventbrite_design_system/card/Card';
import {
    GRID_TYPE,
    STANDARD_STYLE,
} from 'eventbrite_design_system/mediaCardContent/constants';
import {GA_VIEW_NEARBY_CITY_ACTION} from '../constants';

const _formattedName = (name) => (<span className="eds-text-hs eds-text-weight--light eds-text-color--grey-700">{name}</span>);

const _getNearbyPlaceCards = (content, isMobile, trackClick) => {
    const classes = classNames(
        'eds-l-pad-hor-3 eds-l-pad-vert-2',
        {
            'eds-g-cell eds-g-cell-3-12': !isMobile,
            'small-card-mobile small-card-mobile--city': isMobile,
        }
    );

    return content.map(({id, name, url, distance}) => (
        <div key={`${id}_${isMobile}`} className={classes}>
            <Card style="neutral">
                <MediaCardContent
                    shouldShowDivider={true}
                    style={STANDARD_STYLE}
                    type={GRID_TYPE}
                    linkUrl={url}
                    title={_formattedName(name)}
                    subContentOne={distance}
                    onClick={trackClick.bind(null, name)}
                    shouldHideImage={true}
                />
            </Card>
        </div>
    ));
};

export default class NearbyCitiesBucket extends PureComponent {
    static propTypes = {
        trackLocationChange: PropTypes.func.isRequired,
        content: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
                distance: PropTypes.string.isRequired,
            })
        ),
        name: PropTypes.string,
        trackGAEvent: PropTypes.func,
    }

    _handleTrackClick(newLocation) {
        const {trackLocationChange} = this.props;

        trackLocationChange({action: GA_VIEW_NEARBY_CITY_ACTION, newLocation});
    }

    render() {
        const {content, name, trackGAEvent} = this.props;

        return (
            <div>
                <BucketHeader title={name} trackGAEvent={trackGAEvent} />
                <div className="eds-show-up-md eds-g-group">
                    {_getNearbyPlaceCards(content, false, this._handleTrackClick.bind(this))}
                </div>
                <div className="mobile-card-carousel eds-show-down-mn">
                    {_getNearbyPlaceCards(content, true, this._handleTrackClick.bind(this))}
                </div>
            </div>
        );
    }
}
